import React, { useEffect, useRef, useState } from 'react'

import { Spinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool } from 'prop-types'

const LOADING_MESSAGE = 'Loading media'
const COMPLETION_MESSAGE = 'Loading complete'
const COMPLETION_ANNOUNCEMENT_DURATION = 1000

function LoaderOverlay({ isLoading }) {
  const [statusMessage, setStatusMessage] = useState(isLoading ? LOADING_MESSAGE : '')
  const previousIsLoadingRef = useRef(isLoading)
  const completionTimeoutRef = useRef(null)

  useEffect(() => {
    if (isLoading) {
      setStatusMessage(LOADING_MESSAGE)
    } else if (previousIsLoadingRef.current) {
      setStatusMessage(COMPLETION_MESSAGE)
      completionTimeoutRef.current = setTimeout(() => {
        setStatusMessage('')
        completionTimeoutRef.current = null
      }, COMPLETION_ANNOUNCEMENT_DURATION)
    }

    previousIsLoadingRef.current = isLoading

    return () => {
      if (completionTimeoutRef.current) {
        clearTimeout(completionTimeoutRef.current)
        completionTimeoutRef.current = null
      }
    }
  }, [isLoading])

  const shouldRenderOverlay = isLoading || Boolean(statusMessage)

  if (!shouldRenderOverlay) {
    return null
  }

  const loaderClassName = `gallery-area__loader${isLoading ? '' : ' gallery-area__loader--hidden'}`

  return (
    <div className={loaderClassName} role="status" aria-live="polite">
      {isLoading ? (
        <div className="gallery-area__loader-content">
          <Spinner aria-hidden="true" />
        </div>
      ) : null}
      <span className="gallery-area__loader-status-text">{statusMessage}</span>
    </div>
  )
}

LoaderOverlay.propTypes = {
  isLoading: bool.isRequired,
}

export default LoaderOverlay
